import React, { useMemo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import List, { ListTypes } from 'devextreme-react/list';
import SelectBox from 'devextreme-react/select-box';
import axios from 'axios';
import notify from 'devextreme/ui/notify';
import { useMsal } from "@azure/msal-react";

import './UserMenuSection.scss';

import { useUser } from '../../../contexts/user';

import { logout, getApiToken, getPermissions } from '../../../utils/authUtils.js';

export const UserMenuSection = ({ showAvatar, listRef, tenants: propTenants }) => {

  const { instance, accounts } = useMsal();
  const user = JSON.parse(localStorage.getItem('account'));
  const { logo, tenants: contextTenants, selectedTenant, setSelectedTenant, updateUserInfo } = useUser();
  const navigate = useNavigate();

  // Fallback for avatar URL
  const avatarUrl = logo || localStorage.getItem('logo') || "https://randomuser.me/api/portraits";

  // Use tenants from context or props as fallback
  const availableTenants = useMemo(() => {
    let tenantsData = contextTenants && contextTenants.length > 0 ? contextTenants : propTenants;

    // If still no tenants, try localStorage as final fallback
    if (!tenantsData || tenantsData.length === 0) {
      const storedTenants = localStorage.getItem('tenants');
      tenantsData = storedTenants ? JSON.parse(storedTenants) : [];
    }

    return Array.isArray(tenantsData) ? tenantsData : [];
  }, [contextTenants, propTenants]);

  const onTenantChange = useCallback(async (value) => {
    if (selectedTenant === value) return; // Keine Aktion, wenn Wert gleich bleibt

    setSelectedTenant(value); // Sofort setzen, um UI zu synchronisieren

    try {
      const token = await getApiToken(instance, accounts);
      const response = await axios.post(
        `${process.env.REACT_APP_serverEndpoint}/User/ChangeTenant`,
        { tenantId: value },
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      );

      if (response.data == true) {
        await getPermissions(instance, accounts, updateUserInfo);
        notify({
          message: 'Mandant erfolgreich gewechselt',
          position: { at: 'bottom center', my: 'bottom center' }
        }, 'success');
        navigate('/home');
      } else {
        notify({
          message: 'Fehler beim Wechseln des Mandanten',
          position: { at: 'bottom center', my: 'bottom center' }
        }, 'error');
      }
    } catch (error) {
      console.error('Error changing tenant:', error);
      notify({
        message: 'Fehler beim Wechseln des Mandanten',
        position: { at: 'bottom center', my: 'bottom center' }
      }, 'error');
    }
  }, [selectedTenant, setSelectedTenant, updateUserInfo, navigate, instance, accounts]);
  const menuItems = useMemo(
    () => [
      {
        text: 'Logout', 
        icon: 'runner',
        onClick: () => logout(instance),
      },
    ],
    [instance]
  );

  const listElementAttr = {
    class: 'user-info-list'
  };

  const onItemClick = useCallback(({ itemData }) => itemData?.onClick(), []);

  // Custom item template for dropdown
  const tenantItemTemplate = useCallback((item) => {
    if (!item) return null;
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        {item.logo && (
          <img
            src={item.logo}
            alt={item.tenantname}
            style={{ width: '24px', height: '24px', objectFit: 'contain' }}
            onError={e => { e.target.style.display = 'none'; }}
          />
        )}
        <span>{item.tenantname}</span>
      </div>
    );
  }, []);



  return (
    <>
      <div className='user-info'>
        {showAvatar && (
          <div className='image-container'>
            <div
              style={{
                backgroundImage: `url(${avatarUrl})`,
              }}
              className='user-image'
            />
          </div>
        )}
        <div className='user-name'>{user?.name}</div>
      </div>

      {availableTenants.length > 1 && (
        <div className='tenant-selection'>
          <SelectBox
            items={availableTenants}
            value={selectedTenant}
            onValueChanged={(e) => onTenantChange(e.value)}
            placeholder="Mandant auswählen"
            displayExpr="tenantname"
            valueExpr="tenantId"
            searchEnabled={true}
            stylingMode="filled"
            itemRender={tenantItemTemplate}
          />
        </div>
      )}

      <List ref={listRef} elementAttr={listElementAttr} onItemClick={onItemClick} items={menuItems} />

    </>
  );
};
